<template>
  <div class="app-layout">
    <header class="app-header">
      <router-link to="/" class="app-header__brand">
        Экзаменационное тестирование
      </router-link>
    </header>
    <main class="app-main">
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style scoped>
.app-header__brand {
  font-weight: 600;
  font-size: clamp(1rem, 3.5vw, 1.15rem);
  color: inherit;
  text-decoration: none;
}
.app-header__brand:hover {
  color: var(--app-accent, #2563eb);
  text-decoration: none;
}
</style>
